var render = function render(){var _vm=this,_c=_vm._self._c;return _c('device-widget',{attrs:{"status":_vm.status,"sub-status":_vm.subStatus,"name":_vm.name,"node":_vm.node}})
}
var staticRenderFns = []

export { render, staticRenderFns }